import Vue from 'vue'
import Buefy from 'buefy'

Vue.use(Buefy, {
    defaultIconPack: 'fas'
})

let vue = new Vue()

export default class AppToast {
    success(msg) {
        return vue.$toast.open({
            duration: 2000,
            message: msg,
            position: 'is-top',
            type: 'is-success'
        })
    }

    warningNewUpdate(msg) {
        return vue.$toast.open({
            duration: 60000,
            message: msg,
            position: 'is-top',
            type: 'is-warning'
        })
    }

    danger(msg) {
        return vue.$toast.open({
            duration: 5000,
            message: msg,
            position: 'is-top',
            type: 'is-danger'
        })
    }

    warning(msg) {
        return vue.$toast.open({
            duration: 2000,
            message: msg,
            position: 'is-top',
            type: 'is-warning'
        })
    }

    warningNewRelease(msg) {
        return vue.$toast.open({
            duration: 5000,
            message: msg,
            position: 'is-top',
            type: 'is-warning'
        })
    }
}